import { render } from "./SelectDormitory.vue?vue&type=template&id=50dfe579&scoped=true&ts=true"
import script from "./SelectDormitory.vue?vue&type=script&lang=ts"
export * from "./SelectDormitory.vue?vue&type=script&lang=ts"

import "./SelectDormitory.vue?vue&type=style&index=0&id=50dfe579&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50dfe579"]])

export default __exports__